import { createSelector } from 'reselect';
import { getSelectedWidget } from 'src/react/selectedWidget/selectors/getSelectedWidget';

export const getSelectedWidgetId = createSelector(getSelectedWidget, (widget) => widget.id);
